import { apiService } from './api';
// Inventory Properties API (read-only for inventory module)
export var inventoryPropertiesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/inventory/properties/', { params: params });
    },
};
// Inventory Auxiliary API for interface data
export var inventoryAuxiliarApi = {
    getInterfaceData: function (propertyId) {
        return apiService.get('/api/v1/channel_manager/inventory/auxiliar/', {
            params: propertyId ? { property_id: propertyId } : undefined
        });
    },
};
// Inventory Calendar Data API
export var inventoryCalendarApi = {
    getCalendarData: function (params) {
        return apiService.get('/api/v1/channel_manager/inventory/calendar-data/', { params: params });
    },
    saveBulkChanges: function (changes) {
        return apiService.post('/api/v1/channel_manager/inventory/bulk-save/', changes);
    },
};
// Properties API
export var propertiesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/properties/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/properties/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/properties/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/properties/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/properties/".concat(id, "/"));
    },
    toggleStatus: function (id) {
        return apiService.patch("/api/v1/channel_manager/properties/".concat(id, "/toggle_status/"));
    },
    resendToChannelManager: function (id) {
        return apiService.post("/api/v1/channel_manager/properties/".concat(id, "/resend_to_channel_manager/"));
    },
    // Property amenities
    getAmenities: function (propertyId) {
        return apiService.get("/api/v1/channel_manager/property_amenities/", { params: { property: propertyId } });
    },
    createAmenity: function (data) {
        return apiService.post('/api/v1/channel_manager/property_amenities/', data);
    },
    updateAmenity: function (id, data) {
        return apiService.put("/api/v1/channel_manager/property_amenities/".concat(id, "/"), data);
    },
    deleteAmenity: function (id) {
        return apiService.delete("/api/v1/channel_manager/property_amenities/".concat(id, "/"));
    },
    // Property photos
    getPhotos: function (propertyId) {
        return apiService.get("/api/v1/channel_manager/property_photos/", { params: { property: propertyId } });
    },
    createPhoto: function (data) {
        return apiService.post('/api/v1/channel_manager/property_photos/', data);
    },
    updatePhoto: function (id, data) {
        return apiService.put("/api/v1/channel_manager/property_photos/".concat(id, "/"), data);
    },
    deletePhoto: function (id) {
        return apiService.delete("/api/v1/channel_manager/property_photos/".concat(id, "/"));
    },
};
// Room Types API
export var roomTypesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/room_types/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/room_types/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/room_types/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/room_types/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/room_types/".concat(id, "/"));
    },
    sendToChannelManager: function (id) {
        return apiService.post("/api/v1/channel_manager/room_types/".concat(id, "/send_to_channel_manager/"));
    },
    // Room type amenities
    getAmenities: function (roomTypeId) {
        return apiService.get("/api/v1/channel_manager/room_type_amenities/", { params: { room_type: roomTypeId } });
    },
    createAmenity: function (data) {
        return apiService.post('/api/v1/channel_manager/room_type_amenities/', data);
    },
    updateAmenity: function (id, data) {
        return apiService.put("/api/v1/channel_manager/room_type_amenities/".concat(id, "/"), data);
    },
    deleteAmenity: function (id) {
        return apiService.delete("/api/v1/channel_manager/room_type_amenities/".concat(id, "/"));
    },
    // Room type photos
    getPhotos: function (roomTypeId) {
        return apiService.get("/api/v1/channel_manager/room_type_photos/", { params: { room_type: roomTypeId } });
    },
    createPhoto: function (data) {
        return apiService.post('/api/v1/channel_manager/room_type_photos/', data);
    },
    updatePhoto: function (id, data) {
        return apiService.put("/api/v1/channel_manager/room_type_photos/".concat(id, "/"), data);
    },
    deletePhoto: function (id) {
        return apiService.delete("/api/v1/channel_manager/room_type_photos/".concat(id, "/"));
    },
};
// Rate Plans API
export var ratePlansApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/rate_plans/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/rate_plans/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/rate_plans/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/rate_plans/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/rate_plans/".concat(id, "/"));
    },
    sendToChannelManager: function (id) {
        return apiService.post("/api/v1/channel_manager/rate_plans/".concat(id, "/send_to_channel_manager/"));
    },
};
// Rates API
export var ratesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/rates/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/rates/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/rates/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/rates/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/rates/".concat(id, "/"));
    },
    // Bulk operations
    bulkCreate: function (rates) {
        return apiService.post('/api/v1/channel_manager/rates/bulk_create/', { rates: rates });
    },
    bulkUpdate: function (rates) {
        return apiService.post('/api/v1/channel_manager/rates/bulk_update/', { rates: rates });
    },
};
// Availability API
export var availabilityApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/availability/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/availability/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/availability/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/availability/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/availability/".concat(id, "/"));
    },
    // Bulk operations
    bulkCreate: function (availability) {
        return apiService.post('/api/v1/channel_manager/availability/bulk_create/', { availability: availability });
    },
    bulkUpdate: function (availability) {
        return apiService.post('/api/v1/channel_manager/availability/bulk_update/', { availability: availability });
    },
};
// Restrictions API
export var restrictionsApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/restrictions/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/restrictions/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/restrictions/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/restrictions/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/restrictions/".concat(id, "/"));
    },
    // Bulk operations
    bulkCreate: function (restrictions) {
        return apiService.post('/api/v1/channel_manager/restrictions/bulk_create/', { restrictions: restrictions });
    },
    bulkUpdate: function (restrictions) {
        return apiService.post('/api/v1/channel_manager/restrictions/bulk_update/', { restrictions: restrictions });
    },
};
// Channels API
export var channelsApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/channels/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/channels/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/channels/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/channels/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/channels/".concat(id, "/"));
    },
};
// Property Channel Mappings API
export var propertyChannelMappingsApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/property_channel_mappings/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/property_channel_mappings/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/property_channel_mappings/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/property_channel_mappings/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/property_channel_mappings/".concat(id, "/"));
    },
};
// Reservations API
export var reservationsApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/reservations/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/reservations/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/reservations/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/reservations/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/reservations/".concat(id, "/"));
    },
    // Webhook and sync related endpoints
    getBySyncStatus: function (status) {
        return apiService.get("/api/v1/channel_manager/reservations/sync_status/?status=".concat(status));
    },
    getFromChannex: function () {
        return apiService.get('/api/v1/channel_manager/reservations/from_channex/');
    },
    resyncFromChannex: function (id) {
        return apiService.post("/api/v1/channel_manager/reservations/".concat(id, "/resync_from_channex/"));
    },
    markAsSynced: function (id) {
        return apiService.post("/api/v1/channel_manager/reservations/".concat(id, "/mark_as_synced/"));
    },
    getWebhookLogs: function () {
        return apiService.get('/api/v1/channel_manager/reservations/webhook_logs/');
    },
};
// Business Rules APIs
export var cancellationPoliciesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/cancellation_policies/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/cancellation_policies/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/cancellation_policies/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/cancellation_policies/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/cancellation_policies/".concat(id, "/"));
    },
    setDefault: function (id) {
        return apiService.post("/api/v1/channel_manager/cancellation_policies/".concat(id, "/set_default/"));
    },
    sendToChannelManager: function (id) {
        return apiService.post("/api/v1/channel_manager/cancellation_policies/".concat(id, "/send_to_channel_manager/"));
    },
};
export var taxesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/taxes/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/taxes/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/taxes/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/taxes/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/taxes/".concat(id, "/"));
    },
    sendToChannelManager: function (id) {
        return apiService.post("/api/v1/channel_manager/taxes/".concat(id, "/send_to_channel_manager/"));
    },
    syncToChannelManager: function (id) {
        return apiService.post("/api/v1/channel_manager/taxes/".concat(id, "/send_to_channel_manager/"));
    },
};
export var extraServicesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/extra_services/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/extra_services/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/extra_services/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/extra_services/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/extra_services/".concat(id, "/"));
    },
};
// Hotel Policies API
export var hotelPoliciesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/hotel_policies/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/hotel_policies/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/channel_manager/hotel_policies/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/channel_manager/hotel_policies/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/channel_manager/hotel_policies/".concat(id, "/"));
    },
    sendToChannelManager: function (id) {
        return apiService.post("/api/v1/channel_manager/hotel_policies/".concat(id, "/send_to_channel_manager/"));
    },
    getByProperty: function (propertyId) {
        return apiService.get('/api/v1/channel_manager/hotel_policies/by_property/', { params: { property_id: propertyId } });
    },
};
// Companies API
export var companiesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/connection/companies/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/connection/companies/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/connection/companies/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/connection/companies/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/connection/companies/".concat(id, "/"));
    },
};
// Applications API
export var applicationsApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/connection/applications/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/connection/applications/".concat(id, "/"));
    },
};
// Currencies API
export var currenciesApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/system/currencies/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/system/currencies/".concat(id, "/"));
    },
    create: function (data) {
        return apiService.post('/api/v1/system/currencies/', data);
    },
    update: function (id, data) {
        return apiService.put("/api/v1/system/currencies/".concat(id, "/"), data);
    },
    delete: function (id) {
        return apiService.delete("/api/v1/system/currencies/".concat(id, "/"));
    },
};
// Webhooks API
export var webhooksApi = {
    getAll: function (params) {
        return apiService.get('/api/v1/channel_manager/webhooks/', { params: params });
    },
    getById: function (id) {
        return apiService.get("/api/v1/channel_manager/webhooks/".concat(id, "/"));
    },
    getByStatus: function (status) {
        return apiService.get("/api/v1/channel_manager/webhooks/by_status/?status=".concat(status));
    },
    getByEventType: function (eventType) {
        return apiService.get("/api/v1/channel_manager/webhooks/by_event_type/?event_type=".concat(eventType));
    },
    getStats: function () {
        return apiService.get('/api/v1/channel_manager/webhooks/stats/');
    },
    retry: function (id) {
        return apiService.post("/api/v1/channel_manager/webhooks/".concat(id, "/retry/"));
    },
    manageChannexWebhooks: function (data) {
        return apiService.post('/api/v1/channel_manager/webhooks/manage_channex_webhooks/', data);
    },
    testChannexConnection: function (connectionId) {
        return apiService.post('/api/v1/connection/management/test_connection/', { connection_id: connectionId });
    },
};
// Constants API
export var constantsApi = {
    getPropertyConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/properties/');
    },
    getRoomTypeConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/room-types/');
    },
    getRatePlanConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/rate-plans/');
    },
    getGeneralConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/general/');
    },
    getTimezoneSuggestions: function (countryCode) {
        return apiService.get('/api/v1/channel_manager/constants/timezone-suggestions/', {
            params: { country_code: countryCode }
        });
    },
    getCurrencySuggestions: function (countryCode) {
        return apiService.get('/api/v1/channel_manager/constants/currency-suggestions/', {
            params: { country_code: countryCode }
        });
    },
    getCancellationPolicyConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/cancellation-policies/');
    },
    getTaxConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/taxes/');
    },
    getCountriesConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/countries/');
    },
    getRatePlanExtendedConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/rate-plans-extended/');
    },
    getHotelPolicyConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/hotel-policies/');
    },
    getRestrictionConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/restrictions/');
    },
    getWebhookConstants: function () {
        return apiService.get('/api/v1/channel_manager/constants/webhooks/');
    },
};
